export enum TipoMensagem{
  AVISO = 'AVISO',
  ERRO = 'ERRO',
  CONFIRMACAO = 'CONFIRMACAO'
}
